import React from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import { Add, Refresh } from '@mui/icons-material';

const tableHeader = (Translation: any, addEvent: any, refreshData: any) => [
  [
    { type: 'header', label: Translation('title.event.invitation_letter.template.list'), sm: true },
    {
      type: 'custom',
      sm: false,
      render: () => (
        <Tooltip title="Refresh">
          <IconButton style={{ marginRight: 15 }} onClick={refreshData}>
            <Refresh />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      type: 'custom',
      sm: false,
      render: () => (
        <Button variant="contained" color="secondary" onClick={addEvent}>
          <Add />
          {Translation('app.button.add')}
        </Button>
      ),
    },
  ],
];

export default tableHeader;
